import { z } from "zod";

export const getCommentFormSchema = () => {
	return z.object({
		message: z.string().nonempty("Comment cannot be empty"),
	});
};

export type CommentFormModel = z.infer<ReturnType<typeof getCommentFormSchema>>;
